exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".drop.over[data-v-5fa6b463]{border-color:#aaa;background:#ccc}.drag[data-v-5fa6b463]{padding-top:10px}.drag>.drag[data-v-5fa6b463]{padding:10px;background:rgba(0,0,0,.3);width:auto;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fa6b463","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Nested.vue
// module id = 20
// module chunks = 0